import { Builder } from "@builder.io/react";
import HeroBackground from "../components/HeroBackground";
import "../builder-registry";

Builder.registerComponent(HeroBackground, {
  name: "HeroBackground",
  canHaveChildren: true,
  defaultChildren: [
    {
      "@type": "@builder.io/sdk:Element",
      component: {
        name: "Text",
        options: {
          text: "Tu texto aquí",
        },
      },
    },
  ],
  inputs: [
    {
      name: "posterSrc",
      type: "file",
      allowedFileTypes: ["jpeg", "jpg", "png", "webp", "avif"],
    },
    {
      name: "posterAlt",
      type: "text",
    },
    {
      name: "posterPriority",
      type: "boolean",
      defaultValue: true,
    },
    {
      name: "posterQuality",
      type: "number",
      defaultValue: 75,
    },
    {
      name: "videoMp4Src",
      type: "url",
    },
    {
      name: "videoWebmSrc",
      type: "url",
    },
    {
      name: "videoPreload",
      type: "text",
      enum: ["none", "metadata", "auto"],
      defaultValue: "none",
    },
    {
      name: "overlayClassName",
      type: "text",
    },
    {
      name: "enableVideoFromMinWidth",
      type: "number",
      defaultValue: 1024,
    },
    {
      name: "minHeightDesktop",
      type: "text",
      defaultValue: "60vh",
      helperText: "CSS value, e.g. 60vh, 600px",
    },
    {
      name: "minHeightMobile",
      type: "text",
      defaultValue: "50vh",
      helperText: "CSS value, e.g. 50vh, 420px",
    },
  ],
});
